import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ISpace } from '@/interface';
import { fetchSpaceDetail } from '@/services/space';

export interface SpaceState {
  spaceList?: ISpace[];
  spaceInfo: Partial<ISpace> | null;
  loading: boolean;
}

const initialState: SpaceState = {
  spaceList: [],
  spaceInfo: null,
  loading: false,
};

export const getSpaceDetail = createAsyncThunk(
  'space/detail',
  async ({ id, depth }: { id: string, depth?: number }) => fetchSpaceDetail(id, depth),
);

export const space = createSlice({
  name: 'space',

  initialState,

  reducers: {
    clearSpace() {
      return initialState;
    },
    createNewSpace(state) {
      state.spaceInfo = {
        stories: [],
      };
    },
    updateSpaceInfo(state, action) {
      state.spaceInfo = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getSpaceDetail.fulfilled, (state, { payload }) => {
      if (!payload) {
        return initialState;
      }
      return {
        ...state,
        spaceInfo: {
          ...payload?.data,
        },
        loading: false,
      };
    });
  },
});

export const { clearSpace, createNewSpace, updateSpaceInfo, setLoading } = space.actions;

export default space.reducer;
